module.exports = __webpack_public_path__ + "static/media/november_18.e9183e0a.png";